import script from "./DashboardTrendsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTrendsPanel.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTrendsPanel.vue?vue&type=style&index=0&id=abbdd7ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abbdd7ae"]])

export default __exports__